import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import type { NewsItem, CreateNewsPayload } from '../types/news';
import type { PaginatedResponse } from '../types/api';

export function useNewsList() {
  return useQuery({
    queryKey: ['news'],
    queryFn: () => api.get<PaginatedResponse<NewsItem>>('/news'),
  });
}

export function useNewsItem(newsId: string) {
  return useQuery({
    queryKey: ['news', newsId],
    queryFn: () => api.get<NewsItem>(`/news/${newsId}`),
    enabled: !!newsId,
  });
}

export function useCreateNews() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateNewsPayload) => api.post<NewsItem>('/news', payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news'] });
    },
  });
}
